/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import { connect } from 'react-redux';
import { useQuery } from '@apollo/client';
import findContent from '../../../../../gql/queries/findContent';
import Form from './Form';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const FormContainer = ({ brand }) => {
    const SelfAttestationFormQuery = findContent({
        brand: brand.domain,
        contentType: 'marketplace_self_attestation_form',
    });
    const { data, error, loading } = useQuery(SelfAttestationFormQuery);
    if (loading) {
        return <div style={{ height: '170px' }} />;
    }

    if (error) {
        return null;
    }

    const formBuilderData = data?.findContent?.content?.entries?.[0];
    if (formBuilderData === 0 || null || undefined) return null;
    return (
        <Form
            description_copy_html={formBuilderData.description_copy_html}
            disclaimer_copy={formBuilderData.disclaimer_copy}
            form_fields={formBuilderData.form_fields}
            title={formBuilderData.title}
            seo={formBuilderData.seo}
        />
    );
};

FormContainer.propTypes = {
    brand: object.isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});
export default connect(mapStateToProps)(FormContainer);
